import { render, staticRenderFns } from "./AddProductCard.vue?vue&type=template&id=de137f12&scoped=true"
import script from "./AddProductCard.vue?vue&type=script&lang=js"
export * from "./AddProductCard.vue?vue&type=script&lang=js"
import style0 from "./AddProductCard.vue?vue&type=style&index=0&id=de137f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de137f12",
  null
  
)

export default component.exports